import { cx } from "class-variance-authority"
import { type ComponentProps, memo } from "react"

interface FilterCellRootProps extends ComponentProps<"div"> {}

export const FilterCellRoot = memo<FilterCellRootProps>((props) => {
	const { ref, children, className, ...rest } = props
	return (
		<div ref={ref} className={cx("flex w-max min-w-0 max-w-full gap-0.5", className)} {...rest}>
			{children}
		</div>
	)
})
FilterCellRoot.displayName = "FilterCellRoot"
